
import { environment } from 'src/environments/environment';

export class ConsultantsCountries {
  private id: number;
  private country: string;

  constructor(ConsultantsCountries: any) {
    this.id = ConsultantsCountries.id;
    this.country = ConsultantsCountries.country;
  }

  getId(): number {
    return this.id;
  }

  getCountry(): string {
    return this.country;
  }
}